import { apiFetch } from "./client";
import type { MailboxAccount } from "./types";

export interface MailboxInput {
  protocol: "imap" | "pop3";
  host: string;
  port: number;
  use_tls: boolean;
  username: string;
  secret_ref: string;
  folder: string;
  post_action: "move" | "flag" | "leave";
  is_active: boolean;
}

export async function listMailboxes(): Promise<MailboxAccount[]> {
  return apiFetch("/mailboxes");
}

export async function createMailbox(body: MailboxInput): Promise<MailboxAccount> {
  return apiFetch("/mailboxes", { method: "POST", body: JSON.stringify(body) });
}

export async function updateMailbox(
  id: number,
  body: Partial<MailboxInput>,
): Promise<MailboxAccount> {
  return apiFetch(`/mailboxes/${id}`, { method: "PUT", body: JSON.stringify(body) });
}

export async function deleteMailbox(id: number): Promise<{ ok: boolean }> {
  return apiFetch(`/mailboxes/${id}`, { method: "DELETE" });
}
